import React from 'react';
import { Video } from 'lucide-react';

const RecentRecordingsPlaceholder = () => {
    return (
        <div className="text-center p-6 bg-slate-50 rounded-lg border-2 border-dashed border-slate-200 mt-4">
            <div className="flex justify-center items-center mb-3">
                <Video size={32} className="text-slate-300" />
            </div>
            <h4 className="font-bold text-slate-600 text-sm">No hay grabaciones</h4>
            <p className="text-xs text-slate-400 mt-1">
                Los cursos asincrónicos aparecerán aquí.
            </p>
        </div>
    );
};

export default RecentRecordingsPlaceholder;
